export default __webpack_public_path__ + "static/media/khinkali.13148fa9.PNG";